import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import * as React from 'react';
import cx from 'classnames';
import { mergeStyles } from '../../utils';
import { useInputSize, InputSizeContext } from '../../hooks';
import { InputAdornment } from '../../../inputAdornment';
import { Spinner } from '../Spinner';
import inputGroupStyles from '../../../internal/styles/inputWrapperGroup.css';
import inputAdornmentStyles from '../../../internal/styles/inputWrapperAdornment.css';
import { getStyles } from './styles';
export var InputWrapper = React.forwardRef(function InputWrapper(props, ref) {
  var loading = props.loading,
      disabled = props.disabled,
      invalid = props.invalid,
      inline = props.inline,
      leftEnhancer = props.leftEnhancer,
      rightEnhancer = props.rightEnhancer,
      leftAdornment = props.leftAdornment,
      rightAdornment = props.rightAdornment,
      children = props.children,
      cursor = props.cursor,
      sizeProp = props.size,
      width = props.width,
      minWidth = props.minWidth,
      maxWidth = props.maxWidth,
      focused = props.focused,
      rest = _objectWithoutProperties(props, ["loading", "disabled", "invalid", "inline", "leftEnhancer", "rightEnhancer", "leftAdornment", "rightAdornment", "children", "cursor", "size", "width", "minWidth", "maxWidth", "focused"]);

  var size = useInputSize(sizeProp);
  var styles = mergeStyles(getStyles(size), inputGroupStyles, inputAdornmentStyles);
  var leftAdornmentContent = leftAdornment ? leftAdornment : leftEnhancer ? React.createElement(InputAdornment, null, leftEnhancer) : null;
  var rightAdornmentContent = loading ? React.createElement(InputAdornment, null, React.createElement(Spinner, {
    fillColor: "#737a8e"
  })) : rightAdornment ? rightAdornment : rightEnhancer ? React.createElement(InputAdornment, null, rightEnhancer) : null;
  return React.createElement(InputSizeContext.Provider, {
    value: size
  }, React.createElement("div", _extends({}, rest, {
    ref: ref,
    className: cx(styles['input-wrapper'], focused && styles['focused'], invalid && styles['invalid'], disabled && styles['disabled'], inline && styles['inline']),
    style: {
      cursor: cursor,
      width: width,
      minWidth: minWidth,
      maxWidth: maxWidth
    },
    tabIndex: disabled ? -1 : props.tabIndex
  }), leftAdornmentContent && React.createElement("span", {
    className: styles['left-adornment']
  }, leftAdornmentContent), React.createElement("div", {
    className: styles['children-wrapper']
  }, children), rightAdornmentContent && React.createElement("span", {
    className: styles['right-adornment']
  }, rightAdornmentContent)));
});